var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___TTBMRz",
  "KR": "TextualAttachmentPreview.module__previewSurface___TTBMRz",
  "cA": "TextualAttachmentPreview.module__previewActions___TTBMRz",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___TTBMRz",
  "VA": "TextualAttachmentPreview.module__previewActionButton___TTBMRz" + " " + __webpack_require__(790033)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___TTBMRz",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___TTBMRz",
  "vd": "TextualAttachmentPreview.module__previewViewport___TTBMRz",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___TTBMRz",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___TTBMRz",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___TTBMRz",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___TTBMRz",
  "uT": "TextualAttachmentPreview.module__previewCode___TTBMRz",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___TTBMRz",
  "VP": "TextualAttachmentPreview.module__previewError___TTBMRz",
  "Ml": "TextualAttachmentPreview.module__loadingState___TTBMRz",
  "qr": "TextualAttachmentPreview.module__footer___TTBMRz",
  "X1": "TextualAttachmentPreview.module__expandButton___TTBMRz" + " " + __webpack_require__(790033)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___TTBMRz",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___TTBMRz",
  "qt": "TextualAttachmentPreview.module__fileSection___TTBMRz",
  "gM": "TextualAttachmentPreview.module__fileMeta___TTBMRz",
  "Md": "TextualAttachmentPreview.module__fileName___TTBMRz",
  "Ov": "TextualAttachmentPreview.module__fileSize___TTBMRz",
  "zt": "TextualAttachmentPreview.module__footerActions___TTBMRz",
  "uH": "TextualAttachmentPreview.module__controlButton___TTBMRz" + " " + __webpack_require__(790033)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___TTBMRz",
  "tP": "TextualAttachmentPreview.module__languagePopup___TTBMRz",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___TTBMRz",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___TTBMRz",
  "qm": "TextualAttachmentPreview.module__languageEmpty___TTBMRz",
  "xl": "TextualAttachmentPreview.module__languageList___TTBMRz",
  "O6": "TextualAttachmentPreview.module__languageItem___TTBMRz",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___TTBMRz",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___TTBMRz",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___TTBMRz",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___TTBMRz",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___TTBMRz",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___TTBMRz",
  "CR": "TextualAttachmentPreview.module__modalRoot___TTBMRz",
  "Ij": "TextualAttachmentPreview.module__modalLayout___TTBMRz",
  "S3": "TextualAttachmentPreview.module__modalBody___TTBMRz",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___TTBMRz",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___TTBMRz",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___TTBMRz",
};

module.exports = exports;
